import { render } from "./UserAppointments.vue?vue&type=template&id=4cd6829d&scoped=true"
import script from "./UserAppointments.vue?vue&type=script&lang=js"
export * from "./UserAppointments.vue?vue&type=script&lang=js"

import "./UserAppointments.vue?vue&type=style&index=0&id=4cd6829d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd6829d"]])

export default __exports__